import { ErrorScreen } from "./ErrorScreen";

export const NotFoundErrorScreen = () => <ErrorScreen isNotFound />;
